import { afterRender, Component, Input } from '@angular/core';
import { StoryblokDirective } from 'src/app/directive/storyblok.directive';

declare global {
  interface Window {
    Tally: any;
  }
}

@Component({
  selector: 'app-tally',
  imports: [],
  templateUrl: './tally.component.html',
  styleUrl: './tally.component.scss',
})
export class TallyComponent {
  @Input() tally!: string;
  @Input() _editable!: string;

  @Input() _uid!: string;
  @Input() component!: string;

  constructor() {
    afterRender(() => {
      var d = document,
        w = 'https://tally.so/widgets/embed.js',
        v = function () {
          'undefined' != typeof window['Tally']
            ? window['Tally'].loadEmbeds()
            : d
                .querySelectorAll('iframe[data-tally-src]:not([src])')
                .forEach(function (e: any) {
                  e.src = e.dataset.tallySrc;
                });
        };
      if ('undefined' != typeof window['Tally']) v();
      else if (d.querySelector('script[src="' + w + '"]') == null) {
        var s = d.createElement('script');
        (s.src = w), (s.onload = v), (s.onerror = v), d.body.appendChild(s);
      }
    });
  }
}
